// extracted by mini-css-extract-plugin
export default {"container":"expertArea_container__6hllG","title":"expertArea_title__59OiA","body":"expertArea_body__HTQUX","cards":"expertArea_cards__aa2pX","card":"expertArea_card__NLb6r"};